"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { LogIn, Sparkles } from "lucide-react";
import Link from "next/link";

interface AuthModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  returnTo?: string;
}

export function AuthModal({
  open,
  onOpenChange,
  title = "Sign in to continue",
  description = "You need an HRShakti account to access this feature. Join 2M+ HR professionals networking, learning, and leading together.",
  returnTo,
}: AuthModalProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const href = returnTo ? `/auth/login?callbackUrl=${encodeURIComponent(returnTo)}` : "/auth/login";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Sparkles className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center text-lg font-semibold">{title}</DialogTitle>
          <DialogDescription className="text-center text-sm text-muted-foreground leading-relaxed">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4 flex flex-col gap-2">
          <Button asChild className="w-full">
            <Link href={href}>
              <LogIn className="mr-2 h-4 w-4" />
              Sign In
            </Link>
          </Button>
          <Button variant="outline" asChild className="w-full">
            <Link href="/auth/register">Create free account</Link>
          </Button>
        </div>
        <p className="mt-3 text-center text-xs text-muted-foreground">
          Free to join. No credit card required.
        </p>
      </DialogContent>
    </Dialog>
  );
}
